import { IvaCondition } from '../invoices/invoice'
import { BillingFrequency, ServiceType } from '../offerings/offering'
import { PaymentSource, PaymentStatus } from '../payments/payments'
import { DocType } from '../shared'

export enum CollectorAction {
  TO_COLLECTOR = 'to_collector',
  FROM_COLLECTOR = 'from_collector',
  PAYED_COLLECTOR = 'payed_collector',
  PRINT_INVOICES = 'print_invoices',
}

export enum CollectorStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export interface Collector {
  id: string
  userId: string
  code: number
  name: string
  email?: string
  address?: string
  postalCode?: string
  ivaCondition?: IvaCondition
  docNumber?: string
  docType?: DocType
  dateOfBirth?: Date
  genre?: string
  startingDate?: Date
  finishDate?: Date
  sellCommission: number
  commission: number
  phone?: string
  status: CollectorStatus
  contractsCount: number
  totalContractsAmount: number
  commissionAmount: number
}

export interface CollectorBillingPeriodData {
  paymentId: string
  contractId: string
  contractNumber: string
  offeringCode: string
  offeringName: string
  clientName: string
  clientCode: string
  clientAddress: string
  clientPhone: string
  parcelSection: string | null
  parcelFila: number | null
  parcela: number | null
  paymentStatus: PaymentStatus
  totalAmount: number
  outstandingAmount: number
  serviceType: ServiceType
  source: PaymentSource
  description: string
  billingFrequency: BillingFrequency
  periodStart: Date
  paymentPeriodStart: Date
  updatedAt: Date
  deceasedNames: string
}

export const getCollectorFullName = (collector: Collector | null | undefined): string => {
  if (!collector) return 'Sin asignar'
  return `${collector.code} - ${collector.name}`.trim()
}

export const isCollectorActive = (collector: Collector): boolean => {
  return collector.status === CollectorStatus.Active
}

export const formatCollectorStatus = (status: CollectorStatus): string => {
  const statuses: Record<CollectorStatus, string> = {
    [CollectorStatus.Active]: 'Activo',
    [CollectorStatus.Inactive]: 'Inactivo',
  }
  return statuses[status] || status
}
